import { ENewbuildingActionTypes } from '../../actions/newbuilding';
import { INewBuilding } from '../../types/newbuilding';
import { changeReviewReactionType } from '../../utils/changeReviewReactionType';

// oxlint-disable-next-line typescript/no-explicit-any
export function newbuildingReducer(state: INewBuilding = {} as INewBuilding, action: any): INewBuilding {
  switch (action.type) {
    case ENewbuildingActionTypes.SetFavorite:
      return {
        ...state,
        isFavorite: action.payload,
      };

    case ENewbuildingActionTypes.SetFlatViewOrder: {
      return {
        ...state,
        flatViewOrder: {
          ...state.flatViewOrder,
          isEnabled: state.flatViewOrder?.isEnabled || false,
          orderStatus: action.payload,
        },
      };
    }

    case ENewbuildingActionTypes.SetReviewReaction: {
      const { payload } = action;

      return {
        ...state,
        reviews: changeReviewReactionType({
          reviews: state.reviews,
          payload,
        }),
      };
    }

    default:
      return state;
  }
}
